import { Button, Space, Table, Tag } from "antd";
import { useMemo } from "react";
import { EyeOutlined } from "@ant-design/icons";
import PosterContentRenderer from "./PosterContentRenderer";
import RemovePoster from "./RemovePoster";
import ClonePoster from "./ClonePoster";
import dayjs from "../../../utils/dayjs";

const PosterTable = (props) => {
  const { posters, showModal, loading } = props;

  const columns = useMemo(
    () => [
      {
        title: "Created At",
        dataIndex: "created_at",
        key: "created_at",
        render: (date) => new Date(date).toLocaleString(),
      },
      {
        title: "Type",
        dataIndex: "type",
        key: "type",
        render: (type) => <Tag color="blue">{type?.toUpperCase()}</Tag>,
      },
      {
        title: "Status",
        key: "status",
        render: (_, record) => {
          const isExpired =
            dayjs().diff(dayjs(record.created_at), "hour") >= 24;

          return (
            <Tag color={isExpired ? "red" : "green"}>
              {isExpired ? "EXPIRED" : "ACTIVE"}
            </Tag>
          );
        },
      },
      {
        title: "Content",
        key: "content",
        render: (_, record) => <PosterContentRenderer record={record} />,
        width: "50%",
      },

      {
        title: "Actions",
        key: "actions",
        width: 100,
        render: (_, record) => (
          <Space>
            <ClonePoster poster_id={record?.id} />
            <Button
              icon={<EyeOutlined />}
              onClick={() => showModal(record)}
              type="primary"
            />
            <RemovePoster poster_id={record?.id} />
          </Space>
        ),
      },
    ],
    [],
  );

  return (
    <>
      <Table
        columns={columns}
        dataSource={posters}
        rowKey="id"
        loading={loading}
        pagination={{ pageSize: 10 }}
        scroll={{ x: "max-content", y: "calc(100dvh - 186px)" }}
      />
    </>
  );
};

export default PosterTable;
